import { type FC, useEffect } from 'react';
import { useAiRovoCurrentRouteConfigurationStoreActions } from '@jira/ai-rovo_actions-store/src/aiRovoCurrentRouteConfigurationStore.tsx';
import { useSlaConfig } from '@jira/ai-rovo__actions-permissions/src/SlaConfigProviderEntry.tsx';

export const AiRovoSlaNudgesProvider: FC<{}> = (): null => {
	const { updateConfiguration } = useAiRovoCurrentRouteConfigurationStoreActions();
	const slaConfig = useSlaConfig();

	useEffect(() => {
		updateConfiguration({
			nudges: [],
			getActions: slaConfig.getActions,
			tags: slaConfig.tags,
		});
	}, [slaConfig, updateConfiguration]);

	return null;
};
